import React from "react";
import { Redirect } from "react-router-dom";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import AuthLayout from "../pages/Authentication/AuthLayout";
import Logout from "../pages/Authentication/Logout";
import CreateUserAcount from "../pages/Authentication/CreateUserAcount";
import ConfirmUserAcount from "../pages/Authentication/ConfirmUserAcount";
import PasswordChange from "../pages/Authentication/PasswordChange";
import PasswordChangeConfirm from "../pages/Authentication/PasswordChangeConfirm";

import TwostepVerification from "../pages/Authentication/auth-two-step-verification";
import TwostepReadQr from "../pages/Authentication/auth-two-step-readqr";
import LockScreen from "../pages/Authentication/auth-lock-screen";

import QueryBuilderEx from "pages/QueryBuilderExample/queryBuilderExample";

import UserDefinition from "pages/SystemGeneral/UserDefinition/userDefinition";
import UserRoleRelation from "pages/SystemGeneral/UserRoleRelation/userRoleRelation";

import Profile from "../pages/Authentication/UserProfile";
import Dashboard from "pages/Dashboard/index"
import MerchantApplication from "pages/MerchantManagement/merchantApplication";
import TransactionMonitoring from "../pages/TransactionManagement/TransactionMonitoring";
import MerchantReconciliation from "pages/MerchantReconciliation/MerchantReconciliation";
import ChargebackMonitoring from "pages/ChargebackManagement/ChargebackMonitoring";
import keyDefinition from "pages/KeyManagement/keyDefinition";
import MerchantCommissionList from "pages/InstallmentAndCommissionManagement/MerchantCommissionList";
import CheckoutPage from "pages/CheckoutPage/Checkout";
import LinkPaymentList from "pages/GetPaid/LinkPaymentList";
import LinkPaymentSuccess3d from "pages/CheckoutPage/LinkPaymentSuccess3d";
import LinkPaymentFail3d from "pages/CheckoutPage/LinkPaymentFail3d";
import HostedPaymentPageCheckout from "pages/HostedPaymentPage/hostedPaymentPageCheckout";
import HostedPaymentFail3d from "pages/HostedPaymentPage/hostedPaymentFail3d";
import HostedPaymentSuccess3d from "pages/HostedPaymentPage/hostedPaymentSuccess3d";
import refundTransactionMonitoring from "../pages/TransactionManagement/refundTransactionMonitoring";
import suspiciousTransactionMonitoring from "../pages/TransactionManagement/suspiciousTransactionMonitoring";
import transactionReports from "../pages/TransactionReports/transactionReports";
import invoiceReports from "../pages/TransactionReports/invoiceReports";
import createLinkPayment from "../pages/GetPaid/CreateLinkPayment";

//TODO: Agreement Version Management then open
//import MerchantAgreement from "pages/MerchantManagement/merchantAgreement";
 
const authProtectedRoutes = [



  { path: "/userDefinition", component: UserDefinition },
  { path: "/userRoleRelation", component: UserRoleRelation },

  { path: "/Dashboard", component: Dashboard },
  { path: "/profile", component: Profile },
  { path: "/queryBuilder", component: QueryBuilderEx },
  { path: "/merchantApplication", component: MerchantApplication },
  { path: "/transactionMonitoring", component: TransactionMonitoring },
  { path: "/merchantReconciliation", component: MerchantReconciliation },
  { path: "/chargebackMonitoring", component: ChargebackMonitoring },
  { path: "/keyDefinition", component: keyDefinition },
  { path: "/merchantCommissionList", component: MerchantCommissionList },
  { path: "/linkPaymentList", component: LinkPaymentList },
  { path: "/hostedPaymentPage", component: HostedPaymentPageCheckout },
  { path: "/exit", component: Logout },
  { path: "/refundTransactionMonitoring", component: refundTransactionMonitoring },
  { path: "/suspiciousTransactionMonitoring", component: suspiciousTransactionMonitoring },
  { path: "/transactionReports", component: transactionReports },
  { path: "/receipts", component: invoiceReports },
  { path: "/createLinkPayment", component: createLinkPayment },

  //TODO: Agreement Version Management then open
  //  { path: "/merchantAgreement", component: MerchantAgreement },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/Dashboard" /> },
];

const publicRoutes = [
  { path: "/login", component: AuthLayout }, 
  { path: "/loginPage", component: Login,  page: "Login"},
  { path: "/createUserAcount", component: AuthLayout, page: "CreateUserAcount" },
  { path: "/confirmUserAcount", component: AuthLayout, page: "ConfirmUserAcount" },
  { path: "/passwordChange", component: PasswordChange, page: "PasswordChange" },
  { path: "/passwordChangeConfirm", component: PasswordChangeConfirm, page: "PasswordChangeConfirm" }, 
  { path: "/logout", component: Logout },
  { path: "/auth-two-step-verification", component: TwostepVerification },
  { path: "/auth-two-step-readqr", component: TwostepReadQr },
  { path: "/auth-lock-screen", component: LockScreen },
  { path: "/linkpayment", component: CheckoutPage },
  { path: "/linkSuccess", component: LinkPaymentSuccess3d },
  { path: "/linkFail", component: LinkPaymentFail3d },
  { path: "/hostedPaymentPage", component: HostedPaymentPageCheckout },
  { path: "/hostedPaymentFail", component: HostedPaymentFail3d },
  { path: "/hostedPaymentSuccess", component: HostedPaymentSuccess3d },

];

export { authProtectedRoutes, publicRoutes }; 